// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__wh0jL","header":"Messages_header__tFZ5i"};